import { makeVar } from "@apollo/client";

const companyPicVar = makeVar(undefined);

export default companyPicVar;
